/**
 * NOTE - SI VOUS COMPTEZ AJOUTER/MODIFIER DES COLONNES DANS LE CALENDRIER, VOUS DEVRIEZ AU MINIMUM VERIFIER LES IMPACTS AUX ENDROITS SUIVANTS :
 * - Composants planning-filters: Formatter les filtres affichés
 * - Model ResourceTypeEnum: Adapter l'enum
 * - Service resources-manager
 *   - Adapter la construction de resourceId et leur parsing
 *   - Adapter la fonction generateDossierAfterMove(...)
 * - Service planning-sandbox
 *   - Adapter la fonction generateFiltersFromFitters(...)
 *   - Adapter la fonction generateFitterSubfilter(...)
 *   - Adapter la fonction getResources(...)
 *   - Adapter la fonction canDoIntervention(...)
 *   - Adapter la fonction hasAttributeBlockingEvent(...)
 * - Service planning-calendar
 *   - Adapter la fonction constructAllCalendarDossierEvents(...)
 *   - Adapter la fonction choseOpeningPeriod(...)
 * - Composant planning
 *   - Adapter la fonction handleCalendarDateClick(...)
 *   - Adapter la fonction canMoveOrResizeEvent(...)
 *   - Adapter la fonction canUpdateDossierWithoutForm(...)
 * - Composant planning-calendar
 *   - Adapter la fonction buildBottomHeader(...)
 *   - Adapter la couleur de la colonne dans le scss
 */

export interface Resource {
  id: string;
  fitterId: string;
  brand: string;
  city: string;
  type: ResourceType;
  display: boolean;
  timezone: string;
  businessHours?: ResourceBusinessHour | ResourceBusinessHour[];
  fitterComment?: string;
}

export enum ResourceTypeEnum {
  IN_CENTER = 'IN_CENTER',
  OUTSIDE = 'OUTSIDE',
  REPLACEMENTVEHICLE = 'REPLACEMENTVEHICLE',
  TECHNICIAN = 'TECHNICIAN',
  INTERVENTION_VEHICLE = 'INTERVENTION_VEHICLE',
  RV_DETAILED = 'RV_DETAILED',
}
export type ResourceType = `${ResourceTypeEnum}`;

export interface ResourceBusinessHour {
  startTime: string;
  endTime: string;
  daysOfWeek?: number[];
}
